import ModalForm from "./Form";
import ModalFormContinue from "./FormContinue";
import { NEW_COURSE,CLC_CALENDAR, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
    components: { ModalForm,ModalFormContinue },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            isEditContinueModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            tableId: "NEW_COURSE-table",
            rowData: {},
            formId: "NEW_COURSE-form",
            formIdContinue: "NEW_COURSE-form-continue",
            tableColumns: [
                {
                    title: "Semester",
                    type: "custom-html",
                    key: "academic_calendar",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.academic_calendar_name : '-'
                    },
                },
                {
                    title: "Center",
                    type: "custom-html",
                    key: "center",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.name : '-'
                    },
                },
                {
                    title: "Class Name",
                    type: "text",
                    key: "course_name",
                },
                {
                    title: "Teaching Type",
                    type: "custom-html",
                    key: "teaching_type",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.teaching_type_desc : '-'
                    },
                },
                {
                    title: "Teacher",
                    type: "custom-html",
                    key: "teacher",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.full_name : '-'
                    },
                },
                {
                    title: "Side Teacher",
                    type: "custom-html",
                    key: "side_teacher",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.full_name : '-'
                    },
                },
                {
                    title: "Trainer Teacher",
                    type: "custom-html",
                    key: "trainer_teacher",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.full_name : '-'
                    },
                },
                {
                    title: "Day",
                    type: "text",
                    key: "day",
                },
                {
                    title: "CLC Start",
                    type: "text",
                    key: "course_date_clc_start",
                },
                {
                    title: "CLC End",
                    type: "text",
                    key: "course_date_clc_end",
                },
                {
                    title: "Maximum Student",
                    type: "text",
                    key: "maximum_student",
                },
                {
                    title: "Note",
                    type: "text",
                    key: "notes",
                },
                {
                    title: this.$t("is_active"),
                    type: "custom-html",
                    key: "is_active",
                    isVisible: true,
                    modifier: (value) => {
                        let ClassName = "danger";

                        if (value === 1) ClassName = `success`;
                        else if (value === 0) ClassName = `warning`;

                        return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
                            value ? "Active" : "Inactive"
                        }</span>`;
                    },
                },
                {

					title: "Action",
					type: "custom-html",
					key: "id",
					modifier: (value, rowData) => {
              
						var buttonAction = '';
                        buttonAction = `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Continue"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;font-size:11px;margin-right: 3px;white-space: nowrap;"
                                onclick="window.Handlecontinue(${rowData.id},'`+rowData.course_name+`')"
                            >
                                Continue <i class="fas fa-angle-double-right"></i>
                            </button>`;
                        
                        buttonAction += `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Edit"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;margin-right: 3px;"
                                onclick="window.Handleedit(${rowData.id})"
                            >
                                <i class="fa fa-edit"></i>
                            </button>`;
                        buttonAction += `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Delete"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;"
                                onclick="window.Handledelete(${rowData.id})"
                            >
                                <i class="fa fa-trash"></i>
                            </button>`;
                        return buttonAction;
                    }
                }
            ],
            ENDPOINT: NEW_COURSE,
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "NEW_COURSE",
                url: NEW_COURSE,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [],
                // actions: [
                //     {
                //         title: 'Continue',
                //         icon: "repeat",
                //         type: "none",
                //         component: "app-add-modal",
                //         modalId: "NEW_COURSE-form",
                //     },
                //     {
                //         title: this.$t("edit"),
                //         icon: "edit",
                //         type: "none",
                //         component: "app-add-modal",
                //         modalId: "NEW_COURSE-form",
                //     },
                //     {
                //         title: this.$t("delete"),
                //         icon: "trash",
                //         type: "none",
                //         component: "app-confirmation-modal",
                //         modalId: "demo-delete",
                //     },
                // ],
                filters: [
                    // {
                    //     "title": this.$t('inquiry_type'),
                    //     "type": "search",
                    //     "key": "date",
                    //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    // },
                    // {
                    //     "title": this.$t('age'),
                    //     "type": "range-filter",
                    //     "key": "age-range",
                    //     "maxTitle": this.$t('max_age'),
                    //     "minTitle": this.$t('min_age'),
                    //     "sign": ""
                    // },
                    {
                        title: this.$t("is_active"),
                        type: "checkbox",
                        key: "is_active",
                        option: [
                            { id: true, value: "Active" },
                            { id: false, value: "Inactive" },
                        ],
                    },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    mounted() {
        window.addEventListener('academicCalendarChanged', (e) => {
            this.updateAcademicFilter(e.detail.id);
        });
    },
    methods: {
        updateAcademicFilter(id) {
            this.options.url = `${this.ENDPOINT}?semester=${id}`;
            
            if (this.$hub) {
                this.$hub.$emit(`reload-${this.tableId}`);
            }
        },
        /**
         * Delete confirmed $emit Form confirmation modal
         */
        onDelete() {
            let url = `${this.ENDPOINT}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then((response) => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal("hide");
                    this.onCancelDelete();
                    this.$toastr.s(response.data.message);
                    // this.searchAndSelectFilterOptions();
                })
                .catch(({ err }) => {})
                .finally(() => this.$hub.$emit(`reload-${this.tableId}`));
        },
        onCancelDelete() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = "";
        },
    },
};
